import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import fr from '@/locales/fr.json'
import en from '@/locales/en.json'

// Extract wizard namespace from translations
const frWizard = (fr as Record<string, unknown>).wizard ?? {}
const enWizard = (en as Record<string, unknown>).wizard ?? {}

i18n.use(initReactI18next).init({
  resources: {
    fr: {
      translation: fr,
      wizard: frWizard,
    },
    en: {
      translation: en,
      wizard: enWizard,
    },
  },
  lng: 'fr',
  fallbackLng: 'fr',
  defaultNS: 'translation',
  ns: ['translation', 'wizard'],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

export default i18n
